import { useEffect } from "react";
import { PlayerExternalState } from "./useExternalState/useExternalState";
import * as Tone from "tone";
import { logger } from "./logger";

interface Params {
  state: PlayerExternalState;
}

export default function useSyncBpmWithExternalState({ state }: Params) {
  useEffect(() => {
    logger("useSyncBpmWithExternalState: BPM SYNCED", state.bpm);

    Tone.Transport.bpm.value = state.bpm;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.bpm]);
}
